import React, { FC, useState } from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Grid,
  makeStyles,
  Theme,
  Typography,
  TextField,
  DialogActions,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  FormHelperText
} from '@material-ui/core';
import { DialogTitle } from 'components/Dialog';
import { BLACK, RED, WHITE, GREEN_MOBILE, BLUE_PRIMARY, YELLOW_MOBILE, ORANGE_MOBILE, PRIMARY_MOBILE, GREY } from 'constants/colors';
import Close from '@material-ui/icons/Close';
import { WarningRounded } from '@material-ui/icons';

interface Props {
  openDelete: boolean;

  setOpenDelete: React.Dispatch<React.SetStateAction<boolean>>;
  deleteSalesOrderItem: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    borderRadius: '15px',
    padding: '7px 0'
  },

  titleContainer: {
    fontWeight: 500,
    fontSize: '1.2rem',
    color: BLACK,
    paddingLeft: '6px'
  },
  containerContent: {
    [theme.breakpoints.up('md')]: {
      width: '70vh'
    }
  },
  containerAction: {
    marginBottom: theme.spacing(1)
  },
  spacing: {
    marginTop: theme.spacing(2)
  }
}));

const ModalDelete: FC<Props> = props => {
  const classes = useStyles();

  const { openDelete, setOpenDelete, deleteSalesOrderItem } = props;

  return (
    <Dialog
      open={openDelete}
      onClose={() => setOpenDelete(false)}
      //fullWidth={showComponent ? true : false}
      //   style={{ maxHeight: 80 + 'vh', marginTop: showComponent ? '60px' : '0' }}
      scroll='paper'
    >
      <DialogTitle>
        <Grid item container direction='column' alignItems='center' xs={12}>
          <WarningRounded style={{ color: YELLOW_MOBILE, fontSize: '3rem' }} />
          <Typography className={classes.titleContainer}>Hapus Item</Typography>
        </Grid>
      </DialogTitle>
      <DialogContent className={classes.containerContent}>
        <Grid xs={12}>
          <Typography align='center' style={{ fontSize: '1rem' }}>
            Apakah kamu yakin ingin menghapus item ini?
          </Typography>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.containerAction}>
        <Grid item container direction='row' justify='space-evenly' alignItems='center'>
          <Grid xs={5}>
            <Button size='small' fullWidth className={classes.button} variant='outlined' onClick={() => setOpenDelete(false)}>
              Batal
            </Button>
          </Grid>

          <Grid xs={5}>
            <Button size='small' fullWidth className={classes.button} color='primary' onClick={deleteSalesOrderItem}>
              Hapus
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDelete;
